import { render } from "./SoloDevice.vue?vue&type=template&id=2c3e3b06"
import script from "./SoloDevice.vue?vue&type=script&lang=js"
export * from "./SoloDevice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__